//maybe it corresponds to SliderChevron
import React from 'react'
import {Icon} from '@chakra-ui/react'

const RightLightBackgroundIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <circle
                cx="20"
                cy="20"
                r="20"
                transform="matrix(4.37114e-08 1 1 -4.37114e-08 0 0.000183105)"
                fill="white"
            />
            <path
                d="M21.4746 12.9497L20.4496 13.9997L24.5496 18.0997L25.8246 19.2497L11.4746 19.2497L11.4746 20.7497L25.8246 20.7497L24.5496 21.9247L20.4496 25.9997L21.4746 27.0497L28.5246 19.9997L21.4746 12.9497Z"
                fill="black"
            />
        </Icon>
    )
}

export default RightLightBackgroundIcon
